var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginWallpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 503,
    height: 279,
    viewBox: "0 0 503 279",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_829_16926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.883 87.3999C147.793 87.3999 160.691 74.5023 160.691 58.5922C160.691 42.6821 147.793 29.7844 131.883 29.7844C115.974 29.7844 103.076 42.6821 103.076 58.5922C103.076 74.5023 115.974 87.3999 131.883 87.3999Z",
    fill: "#FF6584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.221 147.367H80.8994C80.7225 147.369 80.5457 147.355 80.3713 147.325L147.21 31.5507C147.618 30.8296 148.21 30.2298 148.925 29.8125C149.641 29.3951 150.455 29.1752 151.283 29.1752C152.111 29.1752 152.925 29.3951 153.641 29.8125C154.356 30.2298 154.948 30.8296 155.356 31.5507L200.213 109.244L202.362 112.962L222.221 147.367Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M222.221 147.367H173.97L197.656 112.962L199.361 110.483L200.213 109.245L202.363 112.962L222.221 147.367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.908 147.367H178.676L202.362 112.962L204.067 110.484L234.932 65.6472C236.955 62.7087 241.823 62.5257 244.202 65.093C244.362 65.2681 244.511 65.4532 244.647 65.6472L300.908 147.367Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.788 128.321C341.582 128.321 345.468 124.434 345.468 119.64C345.468 114.846 341.582 110.959 336.788 110.959C331.993 110.959 328.107 114.846 328.107 119.64C328.107 124.434 331.993 128.321 336.788 128.321Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.624 145.787H335.846L336.657 118.333L337.624 145.787Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.814 123.536L338.723 120.895L336.787 124.19L336.579 123.824L336.814 123.536Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.605 126.203L334.696 123.562L336.631 126.856L336.84 126.49L336.605 126.203Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.416 128.321C421.211 128.321 425.097 124.434 425.097 119.64C425.097 114.846 421.211 110.959 416.416 110.959C411.622 110.959 407.736 114.846 407.736 119.64C407.736 124.434 411.622 128.321 416.416 128.321Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.253 145.787H415.475L416.286 118.333L417.253 145.787Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.443 123.536L418.352 120.895L416.417 124.19L416.207 123.824L416.443 123.536Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.234 126.203L414.325 123.562L416.26 126.856L416.469 126.49L416.234 126.203Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.934 119.991C369.015 119.991 374.755 114.251 374.755 107.17C374.755 100.089 369.015 94.3494 361.934 94.3494C354.853 94.3494 349.113 100.089 349.113 107.17C349.113 114.251 354.853 119.991 361.934 119.991Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.17 145.787H360.544L361.741 105.239L363.17 145.787Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.973 112.924L364.792 109.024L361.934 113.89L361.625 113.349L361.973 112.924Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.663 116.863L358.845 112.963L361.702 117.828L362.011 117.288L361.663 116.863Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.199 119.991C400.28 119.991 406.02 114.251 406.02 107.17C406.02 100.089 400.28 94.3494 393.199 94.3494C386.119 94.3494 380.379 100.089 380.379 107.17C380.379 114.251 386.119 119.991 393.199 119.991Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.435 145.787H391.809L393.006 105.239L394.435 145.787Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.238 112.924L396.057 109.024L393.199 113.89L392.89 113.349L393.238 112.924Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.929 116.863L390.11 112.963L392.968 117.828L393.276 117.288L392.929 116.863Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.105 119.991C319.185 119.991 324.925 114.251 324.925 107.17C324.925 100.089 319.185 94.3494 312.105 94.3494C305.024 94.3494 299.284 100.089 299.284 107.17C299.284 114.251 305.024 119.991 312.105 119.991Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.34 145.787H310.714L311.912 105.239L313.34 145.787Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.143 112.924L314.962 109.024L312.105 113.89L311.796 113.349L312.143 112.924Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.835 116.863L309.015 112.963L311.873 117.828L312.182 117.288L311.835 116.863Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.785 279H45.3905C40.119 279 34.8992 277.962 30.0291 275.944C25.1589 273.927 20.7338 270.97 17.0064 267.243C13.2789 263.515 10.3221 259.09 8.30484 254.22C6.28755 249.35 5.24927 244.13 5.24927 238.859C5.24927 233.587 6.28755 228.367 8.30484 223.497C10.3221 218.627 13.2789 214.202 17.0064 210.474C20.7338 206.747 25.1589 203.79 30.0291 201.773C34.8992 199.755 40.119 198.717 45.3905 198.717H462.859C466.953 198.717 470.88 197.09 473.776 194.195C476.671 191.3 478.298 187.373 478.298 183.278C478.298 179.183 476.671 175.256 473.776 172.361C470.88 169.466 466.953 167.839 462.859 167.839H31.4954V143.137H462.859C473.505 143.137 483.715 147.366 491.243 154.894C498.771 162.422 503 172.632 503 183.278C503 193.924 498.771 204.134 491.243 211.662C483.715 219.19 473.505 223.42 462.859 223.42H45.3905C41.2958 223.42 37.3689 225.046 34.4735 227.942C31.5781 230.837 29.9515 234.764 29.9515 238.859C29.9515 242.953 31.5781 246.88 34.4735 249.776C37.3689 252.671 41.2958 254.298 45.3905 254.298H463.785V279Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0786 154.87H46.9343V156.105H66.0786V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.424 154.87H101.279V156.105H120.424V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.769 154.87H155.624V156.105H174.769V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.114 154.87H209.969V156.105H229.114V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.458 154.87H264.314V156.105H283.458V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.803 154.87H318.659V156.105H337.803V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.149 154.87H373.004V156.105H392.149V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.494 154.87H427.349V156.105H446.494V154.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0786 210.451H46.9343V211.686H66.0786V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.424 210.451H101.279V211.686H120.424V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.769 210.451H155.624V211.686H174.769V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.114 210.451H209.969V211.686H229.114V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.458 210.451H264.314V211.686H283.458V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.803 210.451H318.659V211.686H337.803V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.149 210.451H373.004V211.686H392.149V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.494 210.451H427.349V211.686H446.494V210.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0786 266.031H46.9343V267.266H66.0786V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.424 266.031H101.279V267.266H120.424V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.769 266.031H155.624V267.266H174.769V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.114 266.031H209.969V267.266H229.114V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.458 266.031H264.314V267.266H283.458V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.803 266.031H318.659V267.266H337.803V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.149 266.031H373.004V267.266H392.149V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.494 266.031H427.349V267.266H446.494V266.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.882 49.0172C337.893 49.0153 339.872 49.5266 341.63 50.5026H330.148C331.902 49.5269 333.875 49.0156 335.882 49.0172Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.602 47.5318C316.961 47.5279 320.24 48.5658 322.985 50.5026H304.231C306.973 48.5681 310.246 47.5303 313.602 47.5318Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.394 28.7285C187.801 21.5237 190.754 14.6977 195.726 9.46768C200.698 4.23762 207.366 0.943421 214.541 0.172403C221.716 -0.598614 228.932 1.20367 234.902 5.25792C240.871 9.31218 245.207 15.3549 247.136 22.3086C247.505 22.2954 247.874 22.2806 248.246 22.2806C254.824 22.2818 261.226 24.413 266.492 28.3553C271.759 32.2977 275.607 37.8393 277.462 44.151C281.821 42.2356 286.692 41.8201 291.313 42.9694C295.934 44.1188 300.043 46.7681 302.996 50.5026H208.014C205.243 50.5105 202.499 49.9591 199.946 48.8815C197.393 47.8038 195.084 46.2222 193.156 44.2311C191.229 42.2401 189.724 39.8807 188.73 37.2941C187.736 34.7075 187.274 31.9469 187.372 29.1776C187.378 29.0281 187.385 28.8784 187.394 28.7285Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.813 71.2494C340.802 71.2475 338.823 71.7588 337.065 72.7348H348.546C346.793 71.759 344.82 71.2477 342.813 71.2494Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.093 69.764C361.734 69.7601 358.456 70.798 355.71 72.7347H374.464C371.722 70.8002 368.449 69.7624 365.093 69.764Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.301 50.9607C490.894 43.7559 487.941 36.9299 482.969 31.6999C477.997 26.4698 471.329 23.1756 464.154 22.4046C456.979 21.6336 449.763 23.4358 443.793 27.4901C437.823 31.5444 433.488 37.587 431.559 44.5408C431.19 44.5276 430.821 44.5128 430.449 44.5128C423.87 44.514 417.469 46.6452 412.203 50.5875C406.936 54.5299 403.088 60.0715 401.233 66.3832C396.874 64.4678 392.003 64.0522 387.382 65.2016C382.761 66.351 378.652 69.0003 375.698 72.7348H470.681C473.452 72.7426 476.196 72.1912 478.749 71.1136C481.302 70.036 483.611 68.4543 485.538 66.4633C487.466 64.4723 488.971 62.1128 489.965 59.5262C490.959 56.9396 491.421 54.179 491.323 51.4098C491.317 51.2603 491.31 51.1106 491.301 50.9607Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.977 261.737L439.017 261.743L439.018 259.991L427.978 259.985L427.977 261.737Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.162 260.381L350.44 260.908L437.002 260.954L437.78 259.14C439.138 256.029 439.604 252.602 439.126 249.242C438.753 246.737 437.819 244.248 435.697 243.167L431.856 217.582L383.966 217.496L365.437 232.441C365.437 232.441 356.697 232.284 351.949 238.195C350.236 240.393 349.224 243.056 349.046 245.837L348.859 248.912L348.162 260.381Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.175 270.642C373.078 270.642 377.863 265.856 377.863 259.953C377.863 254.049 373.078 249.264 367.175 249.264C361.271 249.264 356.486 254.049 356.486 259.953C356.486 265.856 361.271 270.642 367.175 270.642Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.175 265.578C370.282 265.578 372.8 263.06 372.8 259.953C372.8 256.846 370.282 254.327 367.175 254.327C364.068 254.327 361.549 256.846 361.549 259.953C361.549 263.06 364.068 265.578 367.175 265.578Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.918 270.67C425.821 270.67 430.607 265.884 430.607 259.981C430.607 254.078 425.821 249.292 419.918 249.292C414.015 249.292 409.229 254.078 409.229 259.981C409.229 265.884 414.015 270.67 419.918 270.67Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.918 265.607C423.025 265.607 425.543 263.088 425.543 259.981C425.543 256.874 423.025 254.355 419.918 254.355C416.811 254.355 414.292 256.874 414.292 259.981C414.292 263.088 416.811 265.607 419.918 265.607Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.799 230.694L398.656 230.705H401.812L407.141 230.709V230.32L407.145 225.634L407.149 220.372H403.603L400.447 220.369L394.856 220.365H391.699L385.245 220.361L372.799 230.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.348 230.713L425.013 230.721L425.017 228.039V223.353L425.021 220.384H423.02L419.863 220.38L411.352 220.376L411.348 230.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.384 241.749L407.136 241.75L407.138 238.421L405.386 238.42L405.384 241.749Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.804 235.428L379.805 233.675L376.476 233.673L376.475 235.426L379.804 235.428Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.578 234.446L378.385 234.445C377.904 234.445 377.428 234.35 376.984 234.166C376.54 233.982 376.136 233.712 375.796 233.371C375.456 233.031 375.187 232.627 375.003 232.183C374.819 231.738 374.725 231.262 374.725 230.781C374.725 230.3 374.82 229.824 375.005 229.38C375.189 228.936 375.459 228.532 375.799 228.192C376.139 227.852 376.543 227.583 376.988 227.399C377.432 227.215 377.908 227.121 378.389 227.121L378.582 227.121L378.578 234.446Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.859 248.912C350.184 249.056 351.517 248.728 352.624 247.986C353.731 247.243 354.541 246.134 354.91 244.853C355.279 243.572 355.185 242.202 354.643 240.984C354.101 239.766 353.147 238.779 351.949 238.195C350.236 240.393 349.224 243.056 349.046 245.837L348.859 248.912Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.447 220.369L407.141 230.32L407.145 225.634L403.603 220.372L400.447 220.369Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.864 220.38L425.017 228.039V223.353L423.02 220.384L419.864 220.38Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.699 220.365L398.656 230.705H401.812L394.856 220.365H391.699Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4076 176.485C44.0967 176.485 56.8152 163.766 56.8152 148.077C56.8152 132.388 44.0967 119.669 28.4076 119.669C12.7185 119.669 0 132.388 0 148.077C0 163.766 12.7185 176.485 28.4076 176.485Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5259 156.63L14.3098 142.413C13.8473 141.95 13.5878 141.322 13.5881 140.667C13.5885 140.012 13.8487 139.385 14.3117 138.922C14.7746 138.459 15.4024 138.198 16.0572 138.198C16.7119 138.198 17.34 138.457 17.8034 138.92L28.2895 149.406L61.7513 111.248C62.1835 110.756 62.7931 110.456 63.4463 110.414C64.0995 110.371 64.7427 110.59 65.2348 111.022C65.727 111.453 66.0277 112.062 66.0709 112.715C66.1142 113.369 65.8965 114.012 65.4657 114.505L28.5259 156.63Z",
    fill: "#6C63FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_829_16926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 503,
    height: 279,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginWallpaper);
export default __webpack_public_path__ + "static/media/login_wallpaper.2fd23b8032bfaa70e3f43ff35666044d.svg";
export { ForwardRef as ReactComponent };